import PropTypes from "prop-types";
import { Position, Text, Tooltip, withTheme } from "evergreen-ui";
import TableFooterCell, {
  propTypes as footerCellPropTypes,
} from "./FooterCell";
import { getProps, compose, withMemo } from "./utils";

const TableTextFooterCell = compose(
  ({ cellProps, children, content, textProps = {}, ...props }) => {
    textProps = {
      fontWeight: props.theme.fontWeights.DEMI,
      size: 300,
      ...textProps,
    };

    const getOverflowProps = () => {
      if (!props.maxWidth) return {};

      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      };
    };

    const tableCellProps = {
      ...props,
      ...cellProps,
      ...getOverflowProps(),
    };

    const cellContent = <Text {...textProps}>{content || children}</Text>;

    return (
      <TableFooterCell {...tableCellProps}>
        {props.maxWidth ? (
          <Tooltip
            content={content || children}
            position={Position.BOTTOM_LEFT}
          >
            {cellContent}
          </Tooltip>
        ) : (
          cellContent
        )}
      </TableFooterCell>
    );
  },
  [withMemo, withTheme]
);

export const propTypes = {
  ...footerCellPropTypes,
  children: PropTypes.node,
  content: PropTypes.node,
  textProps: PropTypes.object,
};

TableTextFooterCell.propTypes = propTypes;

// TODO: remove dot notation
TableTextFooterCell.getProps = (props) => getProps(propTypes, props);

export default TableTextFooterCell;
